import React, {useEffect, useState} from 'react';
import axios from "axios";
import {header} from "../../../../../components/api/Header";
import PieChart4 from "../../../../../components/Charts/PieChart4";
import PieChart5 from "../../../../../components/Charts/PieChart5";
import { getEnv } from "../../../../../lib/env";

function Table({date}) {
    const [data, setData] = useState()
    useEffect(()=>{
        const fetchData = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/republik/zarafshon/table?date="+date, header())
                .catch(e=>{
                    console.log("Xato",e)
                })
            if(res){
                setData(res.data)
            }
        }
        fetchData()
    },[date])
    console.log(data)
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-8">
                    <div className="pie-box" style={{height: "300px"}}>
                        <div className="zarafshon-chart-table">
                            <h4>Zarafshon daryosi balansi</h4>
                        </div>
                        <table className="table table-striped zarafshon-table mt-3">
                            <thead>
                            <tr>
                                <th scope="col">№</th>
                                <th scope="col">Viloyatlar nomi</th>
                                <th scope="col">Foiz (%)</th>
                                <th scope="col">Taqsimot bo’yicha</th>
                                <th scope="col">Amalda</th>
                                <th scope="col">Farqi (%)</th>
                            </tr>
                            </thead>
                            {
                                data ?

                                    <tbody>
                                    <tr>
                                        <th scope="row"><span>1</span></th>
                                        <td>Samarqand</td>
                                        <td>70.2%</td>
                                        <td>{taqsimotga(data['taqsimotga'],70.2)}%</td>
                                        <td>{data['tablega']['186']['suvi']}</td>
                                        <td>{farq(data['tablega']['186']['suvi'],taqsimotga(data['taqsimotga'],70.2))}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row"><span>2</span></th>
                                        <td>Jizzax</td>
                                        <td>7.4%</td>
                                        <td>{taqsimotga(data['taqsimotga'],7.4)}%</td>
                                        <td>{data['tablega']['208']['suvi']}</td>
                                        <td>{farq(data['tablega']['208']['suvi'],taqsimotga(data['taqsimotga'],7.4))}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row"><span>3</span></th>
                                        <td>Qashqadaryo</td>
                                        <td>9.3%</td>
                                        <td>{taqsimotga(data['taqsimotga'],9.3)}%</td>
                                        <td>{data['tablega']['209']['suvi']}</td>
                                        <td>{farq(data['tablega']['209']['suvi'],taqsimotga(data['taqsimotga'],9.3))}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row"><span>4</span></th>
                                        <td>Navoiy</td>
                                        <td>13.1%</td>
                                        <td>{taqsimotga(data['taqsimotga'],13.1)}%</td>
                                        <td>{data['tablega']['95']['suvi']}</td>
                                        <td>{farq(data['tablega']['95']['suvi'],taqsimotga(data['taqsimotga'],13.1))}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row"></th>
                                        <td>Jami</td>
                                        <td>100%</td>
                                        <td>{fix(data['taqsimotga'])}</td>
                                        <td>{fix(data['taqsimotboyichajami'])}</td>
                                        <td>{farq(data['taqsimotboyichajami'], data['taqsimotga'])}</td>
                                    </tr>
                                    </tbody>
                                    :null
                            }
                        </table>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="pie-box" style={{height: "300px"}}>
                        <div className="zarafshon-chart-table">
                            <h4>Taqsimot bo’yicha</h4>
                        </div>
                        {data?<PieChart4
                            d1={chartga(data['taqsimotga'],70.2)}
                            d2={chartga(data['taqsimotga'],7.4)}
                            d3={chartga(data['taqsimotga'],9.3)}
                            d4={chartga(data['taqsimotga'],13.1)}
                        />:null}
                    </div>
                </div>
                <div className="col-md-8">
                    <div className="pie-box" style={{height: "327px"}}>
                        <div className="zarafshon-chart-table">
                            <div>
                                <h4 className="m-0">Zarafshon daryosi va Qattaqo’rg’on</h4>
                            </div>
                            <div>
                                <p className="m-0">suv omboridan chiqarilgan suvning taqsimoti</p>
                            </div>
                        </div>
                        <table className="table table-striped zarafshon-table mt-1">
                            <thead>
                            <tr>
                                <th scope="col">№</th>
                                <th scope="col">Manbalar</th>
                                <th width={150} scope="col">Suv sarflari, m3 /s</th>
                            </tr>
                            </thead>
                            {
                                data?
                                    <tbody>
                                    <tr>
                                        <th scope="row"><span>1</span></th>
                                        <td>Ravotxo’ja g/u</td>
                                        <td>{data['tablega']['212']['suvi']}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row"><span>2</span></th>
                                        <td>Kattaqo’rg’on suv ombori kirishi</td>
                                        <td>{data['tablega']['244']['suvi']}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row"><span>3</span></th>
                                        <td>Kattaqo’rg’on suv ombori chiqishi</td>
                                        <td>{data['tablega']['246']['suvi']}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row"></th>
                                        <td>Jami</td>
                                        <td>{fix(data['jami'])}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" className="text-left">Сувнинг йўқолиши 10%</td>
                                        <td>{fix(data['jami']*0.1)}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" className="text-left">Навоий ГРЭС</td>
                                        <td>{data['tablega'][101]['suvi']}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" className="text-left">Тақсимотга</td>
                                        <td>{fix(data['taqsimotga'])}</td>
                                    </tr>
                                    </tbody>
                                    :null
                            }
                        </table>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="pie-box" style={{height: "300px"}}>
                        <div className="zarafshon-chart-table">
                            <h4>Amalda</h4>
                        </div>
                        {data?<PieChart5
                            d1={data['data2'][0]}
                            d2={data['data2'][1]}
                            d3={data['data2'][2]}
                            d4={data['data2'][3]}
                        />:null}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Table;

const check = (a,dv = 1) => {
    if(!a || typeof(a) == 'undefined' || a == 1){
        a = dv;
    }
    return a
}
const taqsimotga = (a,b) => {
    if(!a || typeof(a) == 'undefined' || a == 1){
        a = 1;
    }
    if(!b || typeof(b) == 'undefined' || b == 1){
        b = 1;
    }
    let s = (a * b) / 100
    if(s%1 !== 0){ return s.toFixed(2)}
    return s
}
const farq = (a,b) => {
    if(!a || typeof(a) == 'undefined' || a == 1){
        a = 0;
    }
    if(!b || typeof(b) == 'undefined' || b == 1){
        b = 0;
    }
    let s = a - b
    if(s%1 != 0){ return s.toFixed(2)}
    return s
}

const chartga = (a,f) => {
    if(!a || typeof(a) == 'undefined' || a == 1){
        return 0;
    }
    let s = a / 100 * f;
    if(s%1 !== 0){ return s.toFixed(0)}
    return s
}
const fix = (v) => {
    if(!v || typeof(v) == 'undefined'){
        return '-'
    }else{
        if(v%1 == 0){
            return v
        }else return v.toFixed(2)
    }
}